import React, { useMemo, memo } from "react";
import { useFetchStudents } from "@/hooks/useFetchStudents";
import { FilterContext } from "@/types/FilterContext";
import { FilterState } from "@/components/FilterSidebar/FilterState";
import { StudentOrdering } from "@/types/StudentOrdering";
import {
  SortDirectionEnum,
  StudentListOrganizationSortableFieldEnum,
  YesNoEnum,
} from "@/__generated__/types";
import { StudentCarousel } from "@/components/StudentCarousel";
import { useTranslation } from "react-i18next";
import { useBuildUrlState } from "@/hooks/useUrlSerializer";

export const RecentlyJoinedCarousel = memo(function RecentlyJoinedCarousel({
  title,
  viewAllSource,
  profileSource,
}: {
  title?: string;
  viewAllSource: string;
  profileSource?: string;
}) {
  const { t } = useTranslation();
  const ordering = useMemo(
    () =>
      new StudentOrdering(
        StudentListOrganizationSortableFieldEnum.JoinedAt,
        SortDirectionEnum.Desc,
      ),
    [],
  );

  const {
    items: students,
    loading,
    error,
  } = useFetchStudents({
    paginationVariables: {
      first: 10,
    },
    ordering,
    context: new FilterContext(),
    filterState: new FilterState({ hasProfilePhoto: YesNoEnum.Yes }),
  });

  const orderingQuery = useBuildUrlState("STUDENT_ORDERING")(ordering);
  const errorMsg = error ? t("studentCarousel.genericError") : undefined;

  return (
    <StudentCarousel
      title={title || t("adoption.studentCarousel.title")}
      isLoading={loading}
      students={students}
      viewAllLink={"students"}
      viewAllQuery={orderingQuery}
      viewAllSource={viewAllSource}
      profileSource={profileSource}
      error={errorMsg}
    />
  );
});
